import React from 'react'

function Settings() {
  return (
    <div style={{display:'flex', height:'80vh', border:'40px solid #3d5a80', justifyContent:'center', alignItems:'center'}}>
      Settings
    </div>
  )
}

export default Settings
